export default {
  contact_provider: 'Ota yhteyttä palveluntarjoajaasi ottaaksesi tämän käyttöön.',
};
